<mat-card [ngClass]="[customClass,color]">
  <mat-card-header>
    @if (icon) {
    <div mat-card-avatar class="icon-avatar" [ngClass]="iconSize">
      <mat-icon aria-hidden="false" [class.material-icons-outlined]="isIconOutlined" [aria-label]="icon + '-icon'">{{ icon }}</mat-icon>
    </div>
    }
    @else if (symbol) {
      <div mat-card-avatar class="icon-avatar" [ngClass]="iconSize">
        <mat-icon aria-hidden="false" class="material-symbols-outlined" [aria-label]="symbol + '-symbol'">{{ symbol }}</mat-icon>
      </div>
    }

    @if (title) {
    <mat-card-title>{{ title }}</mat-card-title>
    }
    @else if (titleTmpl) {
    <mat-card-title>
      <ng-container *ngTemplateOutlet="titleTmpl"></ng-container>
    </mat-card-title>
    }

    @if (subtitle) {
    <mat-card-subtitle>{{ subtitle }}</mat-card-subtitle>
    }
    @else if (subtitleTmpl) {
    <mat-card-subtitle>
      <ng-container *ngTemplateOutlet="subtitleTmpl"></ng-container>
    </mat-card-subtitle>
    }
  </mat-card-header>
</mat-card>